import getImageSrcMap from "@/data/system/imageSrcMap.js";
let systemType = require("../../../config/system.js");
const imageSrcMap = getImageSrcMap();

const map = {
    name: systemType.name,
    default: {
        themeColor: "#3DB8C5",
        title: "明树Apaas系统",
        logoUrl: imageSrcMap.system.logo.default,
        fixPhone: "010-86203077",
        fax: "010-86203077",
        email: "contacts@bridata.com",
        address: "北京朝阳区望京科技园F座502",
        zipCode: "100102",
        licenseNumber: "京ICP备17040877号",
        themeName: "明树云",
        loginBg: imageSrcMap.login.loginBg.default,
        registerBg: imageSrcMap.login.loginBg.default
    }
};

export default map;



// WEBPACK FOOTER //
// ./src/data/system/platDataMap.js